export type TabValue = {
    index: string;
    value: ActiveTab;
    label: string;
};

export enum ActiveTab {
    InProgress = 'inProgress',
    Completed = 'completed',
    Cancelled = 'cancelled',
}
